module.exports = __webpack_public_path__ + "static/media/3.97f308c8.jpg";